import React, {Component} from 'react';
import './App.css';
import '@blueprintjs/icons/lib/css/blueprint-icons.css';
import '@blueprintjs/core/lib/css/blueprint.css';
import {
    Button,
    Checkbox,
    Collapse,
    FormGroup,
    H1,
    NumericInput, Pre,
    RangeSlider,
    TextArea
} from "@blueprintjs/core";
import {generate} from "./methods";

class App extends Component {
    constructor(props) {
        super(props);

        const defaultParameters = {"timeSteps": 100, "maxAccelerationMin":1,"maxAccelerationMax":16,"gridWidth":2,"gridHeight":1,"gridSize":1,"roadsPerJunctionMin":1,"roadsPerJunctionMax":4,"signalTimeMin":5,"signalTimeMax":15,"carsPerRoadMin":1,"carsPerRoadMax":5,"targetVelocityMin":71,"targetVelocityMax":105,"targetDecelerationMin":1,"targetDecelerationMax":15,"minDistanceMin":1,"minDistanceMax":6,"targetHeadwayMin":1,"targetHeadwayMax":6,"politenessMin":0.25,"politenessMax":0.75,"routeLengthMin":1,"routeLengthMax":4,"limitMin":60,"limitMax":180,"lanesPerRoadMin":1,"lanesPerRoadMax":3};

        this.state = {params: defaultParameters};
    }

    render() {
        const onChange = (id, val) => {
            this.setState({
                params: {...this.state.params, [id]: val}
            });
        };

        return (
            <div style={{
                margin: '2em 20em'
            }}>
                <H1>Time steps</H1>
                <NumberInput
                    id={"timeSteps"} label={"Time steps"} info={undefined} placeholder={1}
                    min={1} max={undefined} stepSize={1}
                    state={this.state.params} onChange={onChange}
                />

                <H1>Grid size</H1>
                <NumberInput
                    id={"gridWidth"} label={"Width of the grid"} info={undefined} placeholder={1}
                    min={1} max={undefined} stepSize={1}
                    state={this.state.params} onChange={onChange}
                />
                <NumberInput
                    id={"gridHeight"} label={"Height of the grid"} info={undefined} placeholder={1}
                    min={1} max={undefined} stepSize={1}
                    state={this.state.params} onChange={onChange}
                />
                <NumberInput
                    id={"gridSize"} label={"Distance between junctions * 100"} info={undefined} placeholder={1}
                    min={1} max={undefined} stepSize={.1}
                    state={this.state.params} onChange={onChange}
                />

                <H1>Junctions</H1>
                {/*<RangeInput
                    id={"roadsPerJunction"} label={"Connected roads per junction"} info={undefined}
                    min={1} max={4} stepSize={1}
                    state={this.state} onChange={onChange}
                />*/}
                <RangeInput
                    id={"signalTime"} label={"Time between signals"} info={undefined}
                    min={0} max={50} stepSize={5}
                    state={this.state.params} onChange={onChange}
                />

                <H1>Roads</H1>
                <RangeInput
                    id={"lanesPerRoad"} label={"Lanes per road"} info={undefined}
                    min={1} max={3} stepSize={1}
                    state={this.state.params} onChange={onChange}
                />
                <RangeInput
                    id={"limit"} label={"Limit"} info={undefined}
                    min={0} max={200} stepSize={10}
                    state={this.state.params} onChange={onChange}
                />
                <RangeInput
                    id={"carsPerRoad"} label={"Cars per road"} info={undefined}
                    min={1} max={20} stepSize={1}
                    state={this.state.params} onChange={onChange}
                />

                <H1>Cars</H1>
                <RangeInput
                    id={"targetVelocity"} label={"Target Velocity"} info={undefined}
                    min={1} max={300} stepSize={5}
                    state={this.state.params} onChange={onChange}
                />
                <RangeInput
                    id={"maxAcceleration"} label={"Maximum acceleration"} info={undefined}
                    min={1} max={300} stepSize={5}
                    state={this.state.params} onChange={onChange}
                />
                <RangeInput
                    id={"targetDeceleration"} label={"Target Deceleration"} info={undefined}
                    min={1} max={300} stepSize={5}
                    state={this.state.params} onChange={onChange}
                />
                <RangeInput
                    id={"minDistance"} label={"Minimum Distance"} info={undefined}
                    min={1} max={20} stepSize={1}
                    state={this.state.params} onChange={onChange}
                />
                <RangeInput
                    id={"targetHeadway"} label={"Target Headway"} info={undefined}
                    min={1} max={20} stepSize={1}
                    state={this.state.params} onChange={onChange}
                />
                <RangeInput
                    id={"politeness"} label={"Politeness"} info={undefined}
                    min={0} max={1} stepSize={.05}
                    state={this.state.params} onChange={onChange}
                />
                <RangeInput
                    id={"routeLength"} label={"Route Length"} info={undefined}
                    min={1} max={20} stepSize={1}
                    state={this.state.params} onChange={onChange}
                />

                <H1>Parameters</H1>
                <TextArea
                    large={true}
                    fill={true}
                    inputRef={ref => this.parameterBoxRef = ref}
                    onChange={() => {
                        try {
                            const params = JSON.parse(this.parameterBoxRef.value);
                            this.setState({params});
                        } catch (e) {
                        }
                    }}
                    value={JSON.stringify(this.state.params, 4)}
                />

                <H1>Generate</H1>
                <Button icon="chevron-right" intent={"primary"} text={"Generate"} onClick={() => this.setState({output: generate(this.state.params)})} />
                <Checkbox label={'Pretty print'} onChange={() => this.setState({pretty: !this.state.pretty})} checked={this.state.pretty}/>

                <Collapse isOpen={!!this.state.output}>
                    {
                        this.state.pretty
                            ? <Pre>{JSON.stringify(this.state.output, undefined, 4)}</Pre>
                            : <TextArea large={true} fill={true} value={JSON.stringify(this.state.output)}/>
                    }
                </Collapse>
            </div>
        );
    }

}


function NumberInput(props) {
    return (
        <FormGroup
            label={props.label}
            labelInfo={props.info}
            labelFor={props.id}
        >
            <NumericInput
                id={props.id}
                placeholder={props.placeholder}
                min={props.min}
                stepSize={props.stepSize}
                max={props.max}
                value={props.state[props.id]}
                onValueChange={number => props.onChange(props.id, number)}
            />
        </FormGroup>
    );
}

function RangeInput(props) {
    const [min, max] = [props.state[props.id + 'Min'] || props.min, props.state[props.id + 'Max'] || props.max];
    return (
        <FormGroup
            label={props.label}
            labelInfo={props.info}
            labelFor={props.id}
        >
            <RangeSlider
                id={props.id}
                value={[min, max]}
                stepSize={props.stepSize}
                labelStepSize={(props.max - props.min) / props.stepSize < 15 ? props.stepSize : (props.max - props.min) / 20}
                min={props.min}
                max={props.max}
                onChange={value => {
                    props.onChange(props.id + 'Min', value[0]);
                    props.onChange(props.id + 'Max', value[1]);
                }}
            />
        </FormGroup>
    );
}

export default App;
